export default __webpack_public_path__ + "c049949c19c3811741340416da839725.gif";